import axios from 'axios';
import { UserService } from './UserService'
import { getDomainFromUrl, setCookie, getCookie } from '../helper/Helper';


const createAxiosInstance = (baseURL, isTokenRequired) => {
    const instance = axios.create({
        baseURL,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        withCredentials: false,
    });

    // Intercepteur pour ajouter le token d'authentification
    instance.interceptors.request.use((config) => {
        if(isTokenRequired){
            const refreshToken = getCookie('refresh_token');
            const accessToken = sessionStorage.getItem('access_token');
            if (refreshToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }else{
                // redirectToExternalLogin est asynchrone (PKCE) : la redirection part
                // en tache de fond. On rejette la requete au lieu de retourner undefined,
                // qu axios ne sait pas traiter.
                UserService.redirectToExternalLogin();
                return Promise.reject(new Error("Redirection vers l authentification"));
            }
        }
        return config;
    });

    return instance;
};

// Gestion du rafraîchissement du token
const setupTokenRefreshInterceptor = (instance) => {
    instance.interceptors.response.use(
        (response) => response,
        async (error) => {
            if (error.response?.status === 426 || error.response?.status === 423) {
                const bc = new BroadcastChannel("dbUpdate");
                bc.postMessage('updatingFlag');
            }
            if (error.response?.status === 401) {
                const refreshToken = getCookie('refresh_token');
                if (!refreshToken) {
                    UserService.redirectToExternalLogin();
                    return Promise.reject(error);
                }

                // Client public : pas de client_secret. PKCE ne concerne que l echange
                // du code d autorisation ; le refresh ne demande que client_id.
                const dataPost = {
                    client_id: global.config._OAUTH_CLIENT_ID_,
                    grant_type: 'refresh_token',
                    refresh_token: refreshToken,
                };

                try {
                    const res = await UserService.getToken(dataPost);
                    sessionStorage.setItem('access_token', res.data.access_token);
                    setCookie('id_token', res.data.id_token, 24, getDomainFromUrl(global.config._FRONT_URL_));
                    setCookie('refresh_token', res.data.refresh_token, 12, getDomainFromUrl(global.config._FRONT_URL_));

                    // Réexécution de la requête avec le nouveau token
                    error.config.headers.Authorization = `Bearer ${res.data.access_token}`;
                    return axios.request(error.config);
                } catch {
                    UserService.redirectToExternalLogin();
                    return Promise.reject(error);
                }
            }
            return Promise.reject(error);
        }
    );
};

export const axiosAPI = createAxiosInstance(global.config._API_URL_, true);
setupTokenRefreshInterceptor(axiosAPI);

export const axiosOAuth = createAxiosInstance(global.config._OAUTH_PUBLIC_URL_, true);
setupTokenRefreshInterceptor(axiosOAuth);

export const axiosOAuthNoTokenRequired = createAxiosInstance(global.config._OAUTH_PUBLIC_URL_, false);

export const axiosLoginXl = createAxiosInstance(global.config._PROFIL_API_URL_, true);


/* ----------------------------- */
/* 
const token = sessionStorage.getItem('access_token');
export const axiosAPI = axios.create({
    baseURL: global.config._API_URL_,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization' : `Bearer ${token}`
    }
});

// Add a request interceptor
axiosAPI.interceptors.request.use(
    function (config) {
        // Do something before the request is sent
        const token = sessionStorage.getItem('access_token'); // Retrieve auth token from localStorage
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        console.log('---- 1 - Intercepteur Request - config.headers : ')
        console.log(config.headers)
        return config;
    },
    function (error) {
        console.log('---- 1.1 - Intercepteur Request - error : ')
        console.log(error)
        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosAPI.interceptors.response.use(
    function (response) {
        // Do something with the response data
        console.log('---- 2 - Intercepteur Response - response : ')
        console.log(response)
        return response;
    },
    function (error) {

        console.log('---- 2.1 - Intercepteur Response - error : ')
        console.log(error)


        if (error.response) {
            console.log('--------- error.response')
        }
        if (error.response.status === 401) {
            console.log('--------- error.response.status === 401')
        }

        return Promise.reject(error);
    }
);
 */